import script from "./ChangeSiteVersion.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeSiteVersion.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeSiteVersion.vue?vue&type=style&index=0&id=2b175b87&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b175b87"]])

export default __exports__